module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AIImageTextView.js"));
	}, "AIImageTextView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AIImageTextView!./src/pages/AICreation/AIImageText/AIImageTextView.js
// module id = 1306
// module chunks = 418